import { Status } from '@Components/Base';

import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import { TableManageRequestsActions } from '../../tableActions';
import styles from '../request-list-mobile.module.css';

interface CardProps {
  requestNo: number;
  status: string;
  prFor: string;
  requestType: string;
  items: Array<{ label: string; value: string }>;
  showAction: boolean;
  onView: () => void;
  onInitiate: () => void;
  onVendors: () => void;
  onComparison: (recordKey: string, taskId: string) => void;
  onPrevious: () => void;
  onUpdate: () => void;
  onExtention: () => void;
  onCancel: () => void;
  onDelete: () => void;
  onApprovalHistory: () => void;
}

const Card = ({
  requestNo,
  status,
  prFor,
  requestType,
  items,
  showAction,
  onView,
  onVendors,
  onComparison,
  onPrevious,
  onUpdate,
  onExtention,
  onInitiate,
  onCancel,
  onDelete,
  onApprovalHistory,
}: CardProps): JSX.Element | null => {
  return (
    <div className={styles.card}>
      <div className={styles.cardManageSection}>
        <div className={styles.cardType}>{requestType}</div>
        <div className={styles.cardWrap}>
          <div className={styles.cardStatus}>
            <Status text={status} />
          </div>
          {showAction ? (
            <TableManageRequestsActions
              requestNo={requestNo}
              status={status}
              prFor={prFor}
              onView={onView}
              onRfq={onInitiate}
              onVendors={onVendors}
              onComparison={onComparison}
              onPrevious={onPrevious}
              onUpdate={onUpdate}
              onExtention={onExtention}
              onCancel={onCancel}
              onDelete={onDelete}
              onApprovalHistory={onApprovalHistory}
              recordKey={String(requestNo)}
            />
          ) : null}
        </div>
      </div>
      <div className={styles.cardInfoSection}>
        {items?.map((item) => (
          <div key={item.label} className={styles.cardInfoType}>
            <span>{item.label}</span>
            <span
              className={item.value?.length > 10 ? styles.textOverflow : ''}
            >
              {item.value || EMPTY_FIELD_PLACEHOLDER}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Card;
